import { Text } from '@/components/text';

import { CustomLink } from '../custom-link';

export type LinksBlockProps = {
  header: string;
  links: {
    href: string;
    label: string;
  }[];
};
export const LinksBlock = ({ header, links }: LinksBlockProps) => (
  <div className="flex  flex-col gap-b">
    <Text
      variant="h3"
      as="h3"
      accent="none"
    >
      {header}
    </Text>
    {links.map((link) => (
      <div key={link.href}>
        <CustomLink
          href={link.href}
          className="text-blue-500 underline decoration-solid decoration-1 underline-offset-1"
        >
          {link.label}
        </CustomLink>
      </div>
    ))}
  </div>
);
